import { API, Card, Endpoints, Project } from "@brg/api";
import { FlexBox } from "@brg/ui";
import { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ProjectInPartBlock } from "../styles";
import { LayoutConst } from "core";

const DIGITAL_VERSION_SIGN = '_';

export const getCardUrl = (card: any) => {

    const baseUrl = card?.templateType?.context === 'artz' ? process.env.REACT_APP_URL_ARTZ_SHOP : process.env.REACT_APP_URL_GALLERY;
    return `${baseUrl}/card/${card?.cardId}`
}

const Wrapper = styled(ProjectInPartBlock)`
    width: 100%;
    flex-flow: column;
    padding: 16px 24px 16px 24px;
    background-color: transparent;
    gap: 8px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 8px 24px 16px 24px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 16px 24px 16px 24px;
    }
`;

const Item = styled(FlexBox)`
`;

const Name = styled.a`
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    color: #909090;
    text-decoration: none;
    transition: color 0.2s;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    svg path {
        transition fill 0.2s;
    }

    &:hover {
        color: rgb(84, 84, 83);
        transition: color 0.2s;

        svg path {
            fill: rgb(84, 84, 83);
            transition: fill 0.2s;
        }
    
    }
`;

const Title = styled.h1`
    color: #151514;
    font-family: Inter;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.44px;
    margin-bottom: 0;
    text-align: center;
    user-select: none;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 20px;
        line-height: 25px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 17px;
        line-height: 22px;
    }
`;

const LinkWrapper = styled(FlexBox)`

    svg {
        cursor: pointer;
    }

    svg path {
        transition fill 0.2s;
    }

    &:hover {
        ${Name} {
            color: rgb(84, 84, 83);
            transition: color 0.2s;  
        }

        svg path {
            fill: rgb(84, 84, 83);
            transition: fill 0.2s;
        }
    }
`;


export const SubscribeInfo: FC<{ project: Project }> = ({ project }) => {
    const {t, i18n} = useTranslation();
    const [cards, setCards] = useState<Card[]>([])
    const { projectId } = project;

    const fetchCards = async () => {
        await API.request()
        .endpoint(Endpoints.cardsMnePw)
        .url('/api/Card/GetList')
        .addQuery('status', 2)
        .addQuery('subscribedEntityIds', projectId)
        .addQuery('isCopy', 'false')
        .addQuery('isHeaderIgnored', 'true')
        .get()
        .send()
        .then((r) => r.json())
        .then(({ data }) => setCards(API.toLang(data, i18n.language)))
    }

    useEffect(() => {
        fetchCards()
    }, [i18n.language])

    const goToCard = (c: any) => {
        window.open(getCardUrl(c), '_BLANK')
    }

    const CardItem: FC<{ card: Card }> = ({ card }) => {
        
        const subtitle = card.additionalInfo?.find((infoItem) => infoItem.key === 'text_product')?.value

        return <Item>
            <LinkWrapper direction="row" directionMobile={'row'} align="center" alignMobile={'center'} gx={4} gxMobile={4}>
                <Name href={getCardUrl(card)} target="_BLANK">{subtitle || card?.name}</Name>
                <svg onClick={() => goToCard(card)} xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
                    <path d="M1.71474 8L0.5 6.78603L5.62833 1.65587H1.77573L1.7859 0H8.5V6.71492H6.83291L6.84307 2.86984L1.71474 8Z" fill="#909090"/>
                </svg>
            </LinkWrapper>
        </Item>
    }

    const Cards = useMemo(() => {
        if (!!cards?.length) {
            return cards?.map((card) => {
                const isDigital = card?.cardId?.indexOf(DIGITAL_VERSION_SIGN);

                // if (isDigital !== -1) {
                //     return false;
                // }
                
                return (
                    <CardItem card={card} />
                )
            })
        }
        return null;
    }, [cards])

    if (!project?.isBook || !cards?.length) {
        return null;
    }

   return (
    <Wrapper>
        <Title>{t('project_edit.subscribed_card')}</Title>
        {Cards}
    </Wrapper>
   );
}import { API, Card, Endpoints, Project } from "@brg/api";
import { FlexBox } from "@brg/ui";
import { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ProjectInPartBlock } from "../styles";
import { LayoutConst } from "core";

const DIGITAL_VERSION_SIGN = '_';

export const getCardUrl = (card: any) => {

    const baseUrl = card?.templateType?.context === 'artz' ? process.env.REACT_APP_URL_ARTZ_SHOP : process.env.REACT_APP_URL_GALLERY;
    return `${baseUrl}/card/${card?.cardId}`
}

const Wrapper = styled(ProjectInPartBlock)`
    width: 100%;
    flex-flow: column;
    padding: 16px 24px 16px 24px;
    background-color: transparent;
    gap: 8px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 8px 24px 16px 24px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 16px 24px 16px 24px;
    }
`;

const Item = styled(FlexBox)`
`;

const Name = styled.a`
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    color: #909090;
    text-decoration: none;
    transition: color 0.2s;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    svg path {
        transition fill 0.2s;
    }

    &:hover {
        color: rgb(84, 84, 83);
        transition: color 0.2s;

        svg path {
            fill: rgb(84, 84, 83);
            transition: fill 0.2s;
        }
    
    }
`;

const Title = styled.h1`
    color: #151514;
    font-family: Inter;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.44px;
    margin-bottom: 0;
    text-align: center;
    user-select: none;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 20px;
        line-height: 25px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 17px;
        line-height: 22px;
    }
`;

const LinkWrapper = styled(FlexBox)`

    svg {
        cursor: pointer;
    }

    svg path {
        transition fill 0.2s;
    }

    &:hover {
        ${Name} {
            color: rgb(84, 84, 83);
            transition: color 0.2s;  
        }

        svg path {
            fill: rgb(84, 84, 83);
            transition: fill 0.2s;
        }
    }
`;


export const SubscribeInfo: FC<{ project: Project }> = ({ project }) => {
    const {t, i18n} = useTranslation();
    const [cards, setCards] = useState<Card[]>([])
    const { projectId } = project;

    const fetchCards = async () => {
        await API.request()
        .endpoint(Endpoints.cardsMnePw)
        .url('/api/Card/GetList')
        .addQuery('status', 2)
        .addQuery('subscribedEntityIds', projectId)
        .addQuery('isCopy', 'false')
        .addQuery('isHeaderIgnored', 'true')
        .get()
        .send()
        .then((r) => r.json())
        .then(({ data }) => setCards(API.toLang(data, i18n.language)))
    }

    useEffect(() => {
        fetchCards()
    }, [i18n.language])

    const goToCard = (c: any) => {
        window.open(getCardUrl(c), '_BLANK')
    }

    const CardItem: FC<{ card: Card }> = ({ card }) => {
        
        const subtitle = card.additionalInfo?.find((infoItem) => infoItem.key === 'text_product')?.value

        return <Item>
            <LinkWrapper direction="row" directionMobile={'row'} align="center" alignMobile={'center'} gx={4} gxMobile={4}>
                <Name href={getCardUrl(card)} target="_BLANK">{subtitle || card?.name}</Name>
                <svg onClick={() => goToCard(card)} xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
                    <path d="M1.71474 8L0.5 6.78603L5.62833 1.65587H1.77573L1.7859 0H8.5V6.71492H6.83291L6.84307 2.86984L1.71474 8Z" fill="#909090"/>
                </svg>
            </LinkWrapper>
        </Item>
    }

    const Cards = useMemo(() => {
        if (!!cards?.length) {
            return cards?.map((card) => {
                const isDigital = card?.cardId?.indexOf(DIGITAL_VERSION_SIGN);

                // if (isDigital !== -1) {
                //     return false;
                // }
                
                return (
                    <CardItem card={card} />
                )
            })
        }
        return null;
    }, [cards])

    if (!project?.isBook || !cards?.length) {
        return null;
    }

   return (
    <Wrapper>
        <Title>{t('project_edit.subscribed_card')}</Title>
        {Cards}
    </Wrapper>
   );
}